import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Button from "../../../Common/FormElements/Button/Button";

const DeliveryDialogFooter = ({ onCancel, onSubmit, isSubmitDisabled }) => {
  const { t } = useTranslation("common");
  const [loading, setLoading] = useState(false);

  return (
    <div className="deliveryDialogFooter mt-3 d-flex justify-content-center">
      <Button variant="outline" className="me-3" onClick={onCancel}>
        {t("Ignore")}
      </Button>
      <Button
        loading={loading}
        onClick={async () => {
          setLoading(true);
          await onSubmit();
          setLoading(false);
        }}
        disabled={isSubmitDisabled || loading}
      >
        {t("Choose")}
      </Button>
    </div>
  );
};

export default DeliveryDialogFooter;
